import gql from 'graphql-tag'

export default gql`
  mutation PreflightMarketplaceOrder($input: PreflightMarketplaceOrderInput!) {
    preflightMarketplaceOrder(input: $input) {
      success
    }
  }
`

export interface IPreflightMarketplaceOrderVariables {
  input: {
    cartId: string
    total: number
  }
}
